// A media query as React state — phase 8, DM5.
//
// The schedule swaps a view's RENDERING at phone width (the week grid becomes
// the agenda list), which cannot be done in CSS alone: both renderings would
// mount, and each one loads nothing but is a full pass over the window's
// bookings. One hook, kept in lib because nothing about it is schedule-shaped.
import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
